import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isAdminUser } from '../../lib/authRoles';
import { RouteAuthSpinner } from './RouteAuthSpinner';

/** Platform admin only (Domio operators). */
export function AdminOnlyRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <RouteAuthSpinner />;
  if (!isAdminUser(user)) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return children;
}
